const e = {
  justifyContent: "space-between"
}, s = {
  width: "100%",
  height: (r) => r.spacing(0.5),
  bg: "cardOverlay",
  borderRadius: "1px",
  transition: "all"
}, t = {
  progressBar: e,
  progressBarIndicator: s
};
export {
  t as progressBarTheme
};
